import { useLang } from "@/contexts/LanguageContext";
import { useSiteContent } from "@/contexts/SiteContentContext";
import { ExternalLink } from "lucide-react";

const FALLBACK_IMAGES = [
  "https://images.unsplash.com/photo-1569154941061-e231b4725ef1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1692650679395-4e2cb1cdeb2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1657101036247-e0291145a50a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1555992336-fb0d29498b13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1566567270170-15f6d4d53a9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];

const Attractions = () => {
  const { t, lang } = useLang();
  const { content } = useSiteContent();

  const cms = content?.attractions;
  const items = cms?.length
    ? cms.map((it, i) => ({
        t: it.t?.[lang] || it.t?.it || "",
        d: it.d?.[lang] || it.d?.it || "",
        image: it.image || FALLBACK_IMAGES[i % FALLBACK_IMAGES.length],
        url: it.url || "",
      }))
    : t.attractions.items.map((it, i) => ({ ...it, image: FALLBACK_IMAGES[i % FALLBACK_IMAGES.length], url: "" }));

  return (
    <section id="attractions" className="py-20 md:py-28 bg-white" data-testid="attractions-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12">
        <div className="max-w-2xl mb-14">
          <p className="text-overline mb-3">{t.attractions.overline}</p>
          <h2 className="font-display text-4xl md:text-5xl text-[#1E3A5F] leading-tight mb-4">{t.attractions.title}</h2>
          <p className="text-[#635F59] leading-relaxed">{t.attractions.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Wrapper = it.url ? "a" : "article";
            const wrapperProps = it.url
              ? { href: it.url, target: "_blank", rel: "noopener noreferrer" }
              : {};
            return (
            <Wrapper
              key={`${it.t}-${i}`}
              data-testid={`attraction-${i}`}
              className={`group relative overflow-hidden rounded-xl aspect-[4/5] bg-[#1E3A5F] block ${it.url ? "cursor-pointer" : ""}`}
              {...wrapperProps}
            >
              <img
                src={it.image}
                alt={it.t}
                className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A5F] via-[#1E3A5F]/50 to-transparent" />
              {it.url && (
                <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[#AC5D45] opacity-0 group-hover:opacity-100 transition shadow-lg">
                  <ExternalLink className="w-4 h-4" />
                </div>
              )}
              <div className="relative h-full flex flex-col justify-end p-6 text-white">
                <h3 className="font-display text-2xl mb-2">{it.t}</h3>
                <p className="text-sm text-white/85 leading-relaxed">{it.d}</p>
              </div>
            </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Attractions;
